import React, { Component, Fragment } from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { Grid, Header, Button, Tab, Form } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import _ from 'lodash';

import { InputField, SelectField } from 'Common/SemanticWrapper';
import { FileFieldEnum } from 'Common/FieldEnum';
import { renderField } from 'Common/FormHelper';
import { ImportScheduleEnum } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { days } from 'Common/Constants';
import { AUTO_IMPORT_SETUP } from 'Common/FormEnum';
import { MappingTypeEnum } from 'Common/Constants/Enumeration/MappingTypeEnum';
import { FileEncodingOptions } from 'Common/Constants/Enumeration/FileEncodingEnum';

import MappingModal from './../../MappingModal';
import * as actions from './../../state/actions';
import {
  mealsDataMapped,
  mealOptions,
  mealStatuses,
  hours,
  minutes,
  AMorPM,
} from './../../fixtures';

class AutoImportSetupFormContainer extends Component {
  state = {
    showModal: false,
    headerValue: '',
    type: MappingTypeEnum.Meal,
    mealStatusValue: 4,
    changeFile: false,
  };

  headerRowButtons = [
    { title: 'Yes', value: true },
    { title: 'No', value: false },
  ];

  withdrawNotInFileRowButtons = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];

  mealStatusButtons = [
    { title: 'Set Default Meal Status', value: false },
    { title: 'Map Meal Status To Field', value: true },
  ];

  saveData = (data) => {
    const { dispatch } = this.props;
    const { type } = this.state;

    switch (type) {
      case MappingTypeEnum.Language:
        dispatch(actions.addLanguageMappingDataAction(data));
        break;
      case MappingTypeEnum.MealStatus:
        dispatch(actions.addingMealMappingDataAction(data));
        break;
      case MappingTypeEnum.Site:
        dispatch(actions.setSiteMappingDataAction(data));
        break;
      case MappingTypeEnum.Grade:
        dispatch(actions.setGradeMappingDataAction(data));
        break;
      default:
        break;
    }
  };

  // Why does this in the parent? Can it be in te MappingModal?
  updateData = (data) => {
    this.props.change(`${FileFieldEnum.SourceValue}`, data);
  };

  get mappingModalProps() {
    const {
      finalLanguageMappedValues,
      finalMealMappedValues,
      siteOptions,
      sitesMappedDescriptions,
      sitesMapped,
      gradeOptions,
      gradesMappedDescriptions,
      gradesMapped,
      languageDataMapped,
      languageOptions,
    } = this.props;
    const { type } = this.state;

    switch (type) {
      case MappingTypeEnum.Language:
        return {
          headerValue: 'Language Mapping',
          dataMapped: languageDataMapped,
          options: languageOptions,
          finalMappedValues: finalLanguageMappedValues,
          type,
        };
      case MappingTypeEnum.MealStatus:
        return {
          headerValue: 'Meal Status Mapping',
          dataMapped: mealsDataMapped,
          options: mealOptions,
          finalMappedValues: finalMealMappedValues,
          type,
        };
      case MappingTypeEnum.Site:
        return {
          headerValue: 'Site Mapping',
          dataMapped: sitesMappedDescriptions,
          options: siteOptions,
          finalMappedValues: sitesMapped,
          type,
        };
      case MappingTypeEnum.Grade:
        return {
          headerValue: 'Grade Mapping',
          dataMapped: gradesMappedDescriptions,
          options: gradeOptions,
          finalMappedValues: gradesMapped,
          type,
        };
      default:
        return { finalMappedValues: [] };
    }
  }

  toggleModal = (type) => {
    let newState = {
      showModal: !this.state.showModal,
      type,
    };

    this.setState(newState);
  };

  mealStatusPanes = () => {
    return [
      {
        menuItem: 'Set Default Meal Status',
        value: false,
        render: () => (
          <div className="tab--content">
            <label className="d-block">Default Meal Status:</label>
            <Field
              name={FileFieldEnum.MealStatusDropDown}
              component={SelectField}
              options={mealStatuses}
              style={{ width: 'initial' }}
            />
          </div>
        ),
      },
      {
        menuItem: 'Map Meal Status To Field',
        value: true,
        render: () => (
          <div className="tab--content">
            <label className="d-block">Map Meal Status:</label>
            <Button
              type="button"
              onClick={() => this.toggleModal(MappingTypeEnum.MealStatus)}
            >
              Set Custom Map Meal Status
            </Button>
          </div>
        ),
      },
    ];
  };

  render() {
    const {
      dispatch,
      isFirstRowHeader,
      useMappedValue,
      onSubmit,
      onFileEncodingChange,
    } = this.props;
    const { showModal } = this.state;

    return (
      <Fragment>
        <legend>
          <Header content="Import Settings" color="orange" />
        </legend>
        <Form onSubmit={onSubmit}>
          <Grid>
            <Grid.Row />
            <Grid.Row>
              <Grid.Column>
                <label className="d-block">
                  Does the first row contain header information:
                </label>
                <Button.Group basic className="btn-group--active-group">
                  {this.headerRowButtons.map((button) => (
                    <Button
                      key={button.title}
                      basic
                      className="white"
                      active={isFirstRowHeader === button.value}
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(
                          change(
                            AUTO_IMPORT_SETUP,
                            FileFieldEnum.HeaderRowRadio,
                            button.value
                          )
                        );
                      }}
                    >
                      {button.title}
                    </Button>
                  ))}
                </Button.Group>
                <Field
                  name={FileFieldEnum.HeaderRowRadio}
                  component={renderField}
                  props={{ type: 'hidden' }}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  name={FileFieldEnum.FileEncoding}
                  component={SelectField}
                  options={FileEncodingOptions}
                  label="File Encoding"
                  onChange={onFileEncodingChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <ReduxFormButtonGroup
                  formName={AUTO_IMPORT_SETUP}
                  label="Withdraw students not in file:"
                  fieldName={FileFieldEnum.WithdrawNotInFileRowRadio}
                  options={this.withdrawNotInFileRowButtons}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column largeScreen={4}>
                <Field
                  name={FileFieldEnum.EnrolledValue}
                  type="text"
                  component={InputField}
                  label="Enrolled Value"
                  maxLength={10}
                />
              </Grid.Column>
              <Grid.Column largeScreen={4}>
                <Field
                  name={FileFieldEnum.WithdrawnValue}
                  type="text"
                  component={InputField}
                  label="Withdrawn Value"
                  maxLength={10}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <label className="d-block">Meal Status Mapping Options:</label>
                <Tab
                  panes={this.mealStatusPanes()}
                  activeIndex={Number(useMappedValue)}
                  onTabChange={(e, d) => {
                    if (useMappedValue !== !!d.activeIndex) {
                      dispatch(
                        change(
                          AUTO_IMPORT_SETUP,
                          FileFieldEnum.UseMappedValue,
                          !!d.activeIndex
                        )
                      );
                    }
                  }}
                />
                <Field
                  name={FileFieldEnum.UseMappedValue}
                  component={renderField}
                  props={{ type: 'hidden' }}
                  value="false"
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={3}>
              <Grid.Column>
                <label className="d-block">Language Mapping Options:</label>
                <Button
                  type="button"
                  onClick={() => this.toggleModal(MappingTypeEnum.Language)}
                >
                  Set Custom Language Mapping
                </Button>
              </Grid.Column>
              <Grid.Column>
                <label className="d-block">Site Mapping Options:</label>
                <Button
                  type="button"
                  onClick={() => this.toggleModal(MappingTypeEnum.Site)}
                >
                  Set Custom Site Mapping
                </Button>
              </Grid.Column>
              <Grid.Column>
                <label className="d-block">Grade Mapping Options:</label>
                <Button
                  type="button"
                  onClick={() => this.toggleModal(MappingTypeEnum.Grade)}
                >
                  Set Custom Grade Mapping
                </Button>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row />
          </Grid>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <Field
                  name={FileFieldEnum.FileName}
                  type="text"
                  component={InputField}
                  label="Server File Location/File Name"
                  maxLength={256}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={8}>
                <Field
                  multiple
                  selectAllButton
                  selectNoneButton
                  label={'Import Schedule'}
                  component={SelectField}
                  name={ImportScheduleEnum.DaysOfTheWeek}
                  options={days.filter((x) => x.text !== '')}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6} style={{ marginLeft: '13px' }}>
              <Field
                name={ImportScheduleEnum.Hour}
                component={SelectField}
                type="text"
                label=""
                options={hours}
              />
              <div className="text-center text-bold">
                <label>:</label>
              </div>
              <div>
                <label />
              </div>
              <Field
                name={ImportScheduleEnum.Minute}
                component={SelectField}
                type="text"
                label=""
                options={minutes}
              />
              <div>
                <label />
              </div>
              <Field
                name={ImportScheduleEnum.AMorPM}
                component={SelectField}
                type="text"
                label=""
                options={AMorPM}
              />
            </Grid.Row>            
          </Grid>
          <Grid style={{ paddingBottom: '50px' }} />
          <MappingModal
            showEditModal={showModal}
            onClose={this.toggleModal}
            updateData={this.updateData}
            saveData={this.saveData}
            {...this.mappingModalProps}
          />
        </Form>
      </Fragment>
    );
  }
}

const validate = (values, props) => {
  const {importSettingsData} = props;
  
  var errors = {};
  if (
    !values[FileFieldEnum.FileName] ||
    _.trim(values[FileFieldEnum.FileName]).length === 0
  ) {
    errors[FileFieldEnum.FileName] =
      'Server File Location/File Name must be set.';
  }
  
  var hours=values[ImportScheduleEnum.Hour] + (values[ImportScheduleEnum.Hour] === 12 || values[ImportScheduleEnum.AMorPM] === 'AM' ? 0 : 12);  
  const compareTime = (settings)=>!_.isNil(settings.Schedule) && (Number(settings.Schedule.substring(7,9)) === hours && Number(settings.Schedule.substring(9,11)) === values[ImportScheduleEnum.Minute]);
  
  if(importSettingsData.filter((s)=>s.Id!==values[FileFieldEnum.Id]).some(compareTime)){
    errors[ImportScheduleEnum.DaysOfTheWeek] = 'There is already a scheduled import at this time. Please choose another time.';    
  }
  
  
  return errors;
};

const warn = (values, props) => {
  const { touch } = props;
  var warnings = {}
  
  if (
    values[ImportScheduleEnum.DaysOfTheWeek] &&
    values[ImportScheduleEnum.DaysOfTheWeek].length > 0 &&
    (_.isNil(values[ImportScheduleEnum.Hour]) ||
      values[ImportScheduleEnum.Hour].length === 0 ||
      _.isNil(values[ImportScheduleEnum.Minute]) ||
      values[ImportScheduleEnum.Minute].length === 0 ||
      _.isNil(values[ImportScheduleEnum.AMorPM]) ||
      values[ImportScheduleEnum.AMorPM].length === 0 ||
      (values[ImportScheduleEnum.AMorPM] === 'AM' &&
        values[ImportScheduleEnum.Hour] > 7) ||
      (values[ImportScheduleEnum.AMorPM] === 'AM' &&
        values[ImportScheduleEnum.Hour] === 7 &&
        values[ImportScheduleEnum.Minute] > 0) ||
      (values[ImportScheduleEnum.AMorPM] === 'PM' &&
        values[ImportScheduleEnum.Hour] < 2))
  ) {
    warnings[ImportScheduleEnum.DaysOfTheWeek] =
      'Importing students when attempting to serve meals may impact system performance';
      
    const toTouch = [ImportScheduleEnum.DaysOfTheWeek];
    touch(...toTouch);        
  }
    
  return warnings;
}
const AutoImportSetupForm = reduxForm({  
  enableReinitialize: true,
  form: AUTO_IMPORT_SETUP,
  validate,
  warn,
})(withRouter(AutoImportSetupFormContainer));

export { AutoImportSetupForm };



// WEBPACK FOOTER //
// ./src/pages/importstudents/subpages/autoimportsetup/AutoImportSetupForm.js